import React from "react";
import { Card, CardTitle } from "./ui";
import { fmtBRL } from "../../CrmKanban/kanban/tokens";

const MAXH = 140;

// Linha 2 — gráfico de barras (novos x resolvidos) + funil por estágio.
const ChartFunnel = ({
  V,
  chart,
  periodLabel,
  funnel,
  funnelOpenTotal,
  conversao,
}) => {
  const totalNovos = chart.novos.reduce((a, b) => a + b, 0);
  const maxVal = Math.max(1, ...chart.novos, ...chart.resolvidos);
  const maxFunnel = Math.max(1, ...funnel.map((f) => f.value));

  const legend = (color, label) => (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        fontSize: 11,
        fontWeight: 700,
        color: V.sublabel,
      }}
    >
      <span
        style={{ width: 8, height: 8, borderRadius: 2, background: color }}
      />
      {label}
    </span>
  );

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1.6fr 1fr", gap: 12 }}>
      <Card V={V}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span
            style={{
              fontSize: 13.5,
              fontWeight: V.cardTitleWeight,
              color: V.textStrong,
            }}
          >
            {`Tickets · ${periodLabel}: ${totalNovos} novos`}
          </span>
          <span style={{ flex: 1 }} />
          {legend(V.accent, "Novos")}
          {legend(V.good, "Resolvidos")}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            gap: 8,
            height: 170,
            marginTop: 14,
          }}
        >
          {chart.labels.map((label, i) => (
            <div
              key={label + i}
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 6,
                height: "100%",
                justifyContent: "flex-end",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  gap: 3,
                  flex: 1,
                }}
              >
                <div
                  title={`Novos: ${chart.novos[i]}`}
                  style={{
                    width: 15,
                    height: (chart.novos[i] / maxVal) * MAXH,
                    minHeight: chart.novos[i] > 0 ? 3 : 0,
                    background: V.accent,
                    borderRadius: "4px 4px 0 0",
                  }}
                />
                <div
                  title={`Resolvidos: ${chart.resolvidos[i]}`}
                  style={{
                    width: 15,
                    height: (chart.resolvidos[i] / maxVal) * MAXH,
                    minHeight: chart.resolvidos[i] > 0 ? 3 : 0,
                    background: V.good,
                    borderRadius: "4px 4px 0 0",
                    opacity: 0.85,
                  }}
                />
              </div>
              <span
                style={{ fontSize: 10, fontWeight: 700, color: V.labelMuted }}
              >
                {label}
              </span>
            </div>
          ))}
        </div>
      </Card>

      <Card V={V} style={{ gap: 10 }}>
        <CardTitle
          V={V}
          right={
            <span style={{ fontSize: 11.5, fontWeight: 800, color: V.accent }}>
              {fmtBRL(funnelOpenTotal)} abertos
            </span>
          }
        >
          Funil
        </CardTitle>
        <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
          {funnel.map((f) => (
            <div key={f.stageId}>
              <div
                style={{
                  display: "flex",
                  fontSize: 11,
                  fontWeight: 700,
                  color: V.sublabel,
                }}
              >
                <span style={{ flex: 1 }}>{`${f.name} · ${f.count}`}</span>
                <span>{fmtBRL(f.value)}</span>
              </div>
              <div
                style={{
                  height: 8,
                  borderRadius: 4,
                  background: V.track,
                  marginTop: 3,
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: `${Math.max(4, (f.value / maxFunnel) * 100)}%`,
                    background: f.color || "#64748B",
                    borderRadius: 4,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: V.sublabel,
            marginTop: 2,
          }}
        >
          {`Conversão: ${String(conversao.pct).replace(".", ",")}% (${conversao.won} de ${conversao.total} leads)`}
        </div>
      </Card>
    </div>
  );
};

export default ChartFunnel;
